import { useAppKit } from '@reown/appkit/react';
import { useAccount, useDisconnect } from 'wagmi';

// type UseConnectToEvmWalletProps = {};

export const useConnectEvmWallet = () => {
  const { open } = useAppKit();
  const appKitAccount = useAccount();
  const { disconnect } = useDisconnect();

  return {
    address: appKitAccount.address,
    isConnected: appKitAccount.isConnected,
    connect: () => {
      return void open({ view: 'Connect', namespace: 'eip155' });
    },
    disconnect,
  };
};
